import { render, staticRenderFns } from "./LeaderboardChart.vue?vue&type=template&id=1231e107&"
import script from "./LeaderboardChart.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardChart.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardChart.vue?vue&type=style&index=0&id=1231e107&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports